import React from 'react'
import { Star } from 'lucide-react'
import { Button } from 'components/ui'
import { useExecutionText } from '../../hooks/useExecutionText'
import { IRatingFeedback } from '../../model/review'
import styles from './styles.module.css'

interface IProps {
  disabled?: boolean
  rating: number
  ratingFeedback?: IRatingFeedback | null
  isApproved: boolean
  isRejected: boolean
  onRating: (n: number) => void
  onApprove: () => void
  onReject: () => void
  rejectBlocked?: boolean
  onApproveWithReservation?: () => void
}
export const ExecutionReviewActions: React.FC<IProps> = ({
  disabled,
  rating,
  ratingFeedback,
  isApproved,
  isRejected,
  onRating,
  onApprove,
  onReject,
  rejectBlocked,
  onApproveWithReservation,
}) => {
  const t = useExecutionText()

  return (
    <div className="execution-review-actions">
      <div className="execution-rating" role="group" aria-label={t.rating}>
        <span>{t.rating}</span>
        {[1, 2, 3, 4, 5].map((n) => (
          <Button
            type="button"
            isDisabled={disabled}
            key={n}
            variant="ghost"
            aria-label={`${t.rating} ${n} / 5`}
            aria-pressed={rating === n}
            onClick={() => onRating(n)}
          >
            <span
              key={ratingFeedback?.rating === n ? ratingFeedback.id : 'idle'}
              className={`${styles.star}${ratingFeedback?.rating === n ? ` ${styles.pop}` : ''}`}
              data-rating-feedback={ratingFeedback?.rating === n ? n : undefined}
              aria-hidden="true"
            >
              <Star size={20} color={n <= rating ? '#e8a51c' : '#d8dde0'} fill={n <= rating ? '#e8a51c' : '#d8dde0'} />
            </span>
          </Button>
        ))}
      </div>
      <div className="execution-review-buttons">
        {onApproveWithReservation && (
          <Button isDisabled={disabled} variant="ghost" className="execution-link" onClick={onApproveWithReservation}>
            {t.approveWithReservation}
          </Button>
        )}
        {!rejectBlocked && (
          <Button isDisabled={disabled} variant="secondary" className="execution-reject" onClick={onReject}>
            {isRejected ? t.rejected : t.reject}
          </Button>
        )}
        <Button isDisabled={disabled || isApproved} variant="primary" className="execution-approve" onClick={onApprove}>
          {isApproved ? t.approved : t.approve}
        </Button>
      </div>
    </div>
  )
}
